"use strict";
import initializer from "./initializer";
import logging from "./logging";

module.exports = (flex = window.flex) => {

    const { getStore } = flex;

    initializer(flex);

    window.__environment = {};

    const { appContext: { isDevMode } } = getStore();
    Object.assign(window.
        __environment, { console: logging(isDevMode, flex) });
};